import React, { useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { FaArrowLeft, FaUsers, FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import styles from "./Register.module.css";
import Circle from "../../assets/Frame 155 circle.svg";
import OLogo from "../../assets/OGUN STATE LOGO 1 (1).png";
import House from "../../assets/household.png";
import Gov from "../../assets/government.png";
import Info from "../../assets/info-circle.png";

const RegisterPage = () => {
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();

  const handleContinue = () => {
    if (selected === "household") {
      navigate("/nin_reg");
    } else if (selected === "government") {
      navigate("");
    }
  };

  return (
     <div className={styles.wrapper}>
      {/* <Row className="h-100"> */}

        {/* LEFT SECTION */}
          <div className={styles.leftSection}>
          <div className={styles.leftContent}>

            <div className={styles.logo}>
              <img src={OLogo} className={styles.logoImg} alt="logo" />
              <div className={styles.logoText}>
                <h6>OGUN STATE</h6>
                <p>Social Registry</p>
              </div>
            </div>

            <h2>
              Create your <span>account</span>
            </h2>

            <p className={styles.desc}>
              Register your household or create a staff account. It's free and
              takes about 5 minutes
            </p>

            <ul className={styles.list}>
              <li>Secure and confidential handling of your information</li>
              <li>Quick registration in under 5 minutes</li>
              <li>Simple step-by-step process</li>
              <li>Required for access to government support programs</li>
              <li>Option to save and continue later</li>
            </ul>
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div className={styles.rightSection}>
          <div className={styles.rightContent}>

            <div className={styles.back} onClick={() => navigate("/")}>
              <FaArrowLeft style={{marginRight: "10px"}} /> Back to Home
            </div>

            <h4 className={styles.regtext}>Who are you registering as?</h4>
            <p className={styles.sub}>
              Choose the type of account that applies to you
            </p>

            {/* CARDS */}
            <Row className="mt-4">

              <Col md={6} className="mb-3">
                <Card
                  className={`${styles.card} ${
                    selected === "household" ? styles.active : ""
                  }`}
                  onClick={() => setSelected("household")}
                >
                  <Card.Body>
                    <img src={House} className={styles.icon} alt="Household" />
                    <h5 className={styles.cardTitle}>Household</h5>
                    <p className={styles.smtxt}>
                      I am registering my household for social welfare
                      assessment
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6} className="mb-3">
                <Card
                  className={`${styles.card} ${
                    selected === "government" ? styles.active : ""
                  }`}
                  onClick={() => setSelected("government")}
                >
                  <Card.Body>
                    <img src={Gov} className={styles.icon} alt="Government" />
                    <h5 className={styles.cardTitle}>Government Staff</h5>
                    <p className={styles.smtxt}>
                      I am a field enumerator, LGA officer, or ministry official
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* NOTE */}
            <div className={styles.note}>
              <div className={styles.noteimg}>
                <img src={Info} alt="Circle" className={styles.infoIcon} />
              </div>
              <p>
                <strong>Note:</strong> Government staff accounts require approval
                from a system administrator before they can be activated. You
                will receive an email once your account is approved
              </p>
            </div>

            <hr />

            {/* FOOTER */}
            <div className={styles.footer}>
              {/* <span>1 of 5</span> */}

              <button
                className={styles.continueBtn}
                disabled={!selected}
                onClick={handleContinue}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      {/* </Row> */}
    </div>
  );
};

export default RegisterPage;